import { Account } from '../Account/accountApi'

export const shouldShowAiAssistant = (currentUser: Account | undefined): boolean => {
  if (currentUser?.isSuperUser) {
    return true
  }
  return currentUser?.roles?.includes('Administrator') ?? false
}
